//组织机构 医护信息

//引入接口文档
import req from '@/utils/req.js'
//医护人员禁用
export function offDisable(params) {
  return req.put(`/admin/doctor/${params}/disable`)
}
//医护人员启用
export function offEnable(params) {
  return req.put(`/admin/doctor/${params}/enable`)
}

//医护信息分页查询
export function api_doctor_search(params) {
  return req.post('/admin/doctor/search2', params)
}
//医护信息分页查询
export function api_doctor_search2(params) {
  return req.post('/admin/doctor/search', params)
}
//医护人员详细查询
export function getDoctor(params) {
  return req.get(`/admin/doctor/${params}`)
}

//医护团队人员删除
export function renmoveDoctor(params) {
  return req.delete(`/admin/doctor-team-member/${params}`)
}

//医护人员更新
export function updetaDoctor(params) {
  return req.put(`/admin/doctor`, params)
}

/**
 *                                           =============================
 *                                           =      身份证信息模块         =
 *                                           =============================
 */
//批准
export function approveDoctor(params) {
  return req.put(`/admin/certificate-id-card/${params}/approve`)
}
//驳回
export function rejectDoctor(params) {
  return req.put(`/admin/certificate-id-card/${params}/reject`)
}
//证明-身份证删除
export function removerCertificateDoctor(params) {
  return req.delete(`/admin/certificate-id-card/${params}`)
}
//证明-身份证更新
export function updetaCertificateDoctor(params) {
  return req.put(`/admin/certificate-id-card`, params)
}
//证明-身份证添加
export function addetCertificateDoctor(params) {
  return req.post(`/admin/certificate-id-card`, params)
}

/**
 *                                           =============================
 *                                           =      资格证信息模块         =
 *                                           =============================
 */
//批准
export function approveQualificationDoctor(params) {
  return req.put(`/admin/certificate-qualification/${params}/approve`)
}
//驳回
export function rejectQualificationDoctor(params) {
  return req.put(`/admin/certificate-qualification/${params}/reject`)
}
//证明-资格证删除
export function removerQualificationDoctor(params) {
  return req.delete(`/admin/certificate-qualification/${params}`)
}
//证明-资格证更新
export function updetaQualificationDoctor(params) {
  return req.put(`/admin/certificate-qualification`, params)
}
//证明-资格证添加
export function addetQualificationDoctor(params) {
  return req.post(`/admin/certificate-qualification`, params)
}

/**
 *                                           =============================
 *                                           =      执业证信息模块         =
 *                                           =============================
 */
//批准
export function approvePracticeDoctor(params) {
  return req.put(`/admin/certificate-practice/${params}/approve`)
}
//驳回
export function rejectePracticeDoctor(params) {
  return req.put(`/admin/certificate-practice/${params}/reject`)
}
//证明-执业证删除
export function removerePracticeDoctor(params) {
  return req.delete(`/admin/certificate-practice/${params}`)
}
//证明-执业证更新
export function updetaePracticeDoctor(params) {
  return req.put(`/admin/certificate-practice`, params)
}
//证明-执业证添加
export function addetePracticeDoctor(params) {
  return req.post(`/admin/certificate-practice`, params)
}

/**
 *                                           =============================
 *                                           =      职称证信息模块         =
 *                                           =============================
 */
//批准
export function approveTitleDoctor(params) {
  return req.put(`/admin/certificate-title/${params}/approve`)
}
//驳回
export function rejecteTitleDoctor(params) {
  return req.put(`/admin/certificate-title/${params}/reject`)
}
//证明-职称业证删除
export function removereTitleDoctor(params) {
  return req.delete(`/admin/certificate-title/${params}`)
}
//证明-职称证更新
export function updetaeTitleDoctor(params) {
  return req.put(`/admin/certificate-title`, params)
}
//证明-职称证添加
export function addeteTitleDoctor(params) {
  return req.post(`/admin/certificate-title`, params)
}

/**
 *                                           =============================
 *                                           =      多点执业证信息模块         =
 *                                           =============================
 */
//批准
export function approveSitePracticeDoctor(params) {
  return req.put(`/admin/certificate-multi-site-practice/${params}/approve`)
}
//驳回
export function rejecteSitePracticeDoctor(params) {
  return req.put(`/admin/certificate-multi-site-practice/${params}/reject`)
}
//证明-多点执业证删除
export function removereSitePracticeDoctor(params) {
  return req.delete(`/admin/certificate-multi-site-practice/${params}`)
}
//证明-多点执业证更新
export function updetaeSitePracticeDoctor(params) {
  return req.put(`/admin/certificate-multi-site-practice`, params)
}
//证明-多点执业证添加
export function addeteSitePracticeDoctor(params) {
  return req.post(`/admin/certificate-multi-site-practice`, params)
}

/**
 *                                           =============================
 *                                           =  互联网医院聘任合同信息模块  =
 *                                           =============================
 */
//批准
export function approveemploymentDoctor(params) {
  return req.put(`/admin/certificate-employment-contract/${params}/approve`)
}
//驳回
export function rejecteemploymentDoctor(params) {
  return req.put(`/admin/certificate-employment-contract/${params}/reject`)
}

//证明-聘用合同删除
export function removeremploymentDoctor(params) {
  return req.delete(`/admin/certificate-employment-contract/${params}`)
}
//证明-多点执业证更新
export function updetaemploymentDoctor(params) {
  return req.put(`/admin/certificate-employment-contract`, params)
}
//证明-多点执业证添加
export function addetemploymentDoctor(params) {
  return req.post(`/admin/certificate-employment-contract`, params)
}
/**
 *                                           =============================
 *                                           =          收入账户模块      =
 *                                           =============================
 */
//医生银行卡添加
export function addDoctorBankCard(params) {
  return req.post(`/admin/doctor-bank-card`, params)
}
//医生银行卡删除
export function removeDoctorBankCard(params) {
  return req.delete(`/admin/doctor-bank-card/${params}`)
}
